import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotAsyncChat" */ "./lazyIndex"), { name: "CopilotAsyncChat" });

export const lazyStartAsyncChat: LazyAction<typeof lazyIndex.startAsyncChat, typeof lazyModule> = new LazyAction(lazyModule, m => m.startAsyncChat);

export const lazySeedAsyncItems: LazyAction<typeof lazyIndex.seedAsyncItems, typeof lazyModule> = new LazyAction(lazyModule, m => m.seedAsyncItems);

export const lazyMarkAsyncItemRead: LazyAction<typeof lazyIndex.markAsyncItemRead, typeof lazyModule> = new LazyAction(lazyModule, m => m.markAsyncItemRead);
